class MiniCart extends HTMLElement {
    constructor() {
      super();
  
      this.miniCart = document.querySelector('#mini-cart-drawer');
      this.body = document.querySelector('body');
      this.html = document.querySelector('html');
      this.headerCart = document.querySelector('#mini-cart-button');
      this.miniCartLoading = this.miniCart.querySelector('.mini-cart--loading');
      this.initializeCart();
    }
  
    initializeCart() {
      this.bindGlobalEvents();
      this.bindEvents();
    }
    
    bindGlobalEvents() {
      this.headerCart.addEventListener('click', e => {
        e.preventDefault();
        this.open();
      })
  
      const openCartElements = document.querySelectorAll('[data-open-mini-cart]');
      if (openCartElements.length) {
        openCartElements.forEach(el => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.open();
          });
        });
      }
  
      this.closeButtonEvent();
    }
    
  
    bindEvents() {
      const removeButtons = document.querySelectorAll('.mini-cart--item-delete');
      if (removeButtons.length) {
        removeButtons.forEach(el => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            const lineID = e.target.closest('.mini-cart--item').dataset.lineItem;
            this.deleteCart(lineID)
          });
        });
      }
  
      const quantityButtons = document.querySelectorAll('.mini-cart .quantity__button');
      if (quantityButtons.length) {
        quantityButtons.forEach(el => {
          el.addEventListener('click', (e) => {
            const quantityInput = e.target.parentNode.querySelector('.quantity__input');
            const errorContainer = e.target.closest('.mini-cart--item').querySelector('.quantity__error');
            const quantityVal = quantityInput.value;
            const currentLineID = quantityInput.dataset.index;
            this.updateCart(currentLineID, quantityVal, errorContainer, quantityInput);
          });
        });
      }
    }
  
    closeButtonEvent() {
      const closeCartElements = document.querySelectorAll('[data-close-mini-cart]');
      if (closeCartElements.length) {
        closeCartElements.forEach(el => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.close();
          });
        });
      }
  
    }
    
  
    open() {
      this.miniCart.classList.add('active');
      this.body.classList.add('mini-cart-active');
      this.html.classList.add('mini-cart-active');
    }
  
    close() {
      this.miniCart.classList.remove('active');
      this.body.classList.remove('mini-cart-active');
      this.html.classList.remove('mini-cart-active');
    }
  
    updateHeaderCart(quantity) {
      this.headerCart.querySelector('.cart-link').textContent = quantity;
    }
  
    updateView(openMiniCart=false) {
    fetch('/cart?view=ajax').then(res => res.text()).then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const cartOption = JSON.parse(doc.querySelector('[data-options]').innerHTML);
        const updatedContent = doc.querySelector('[data-html]').content.querySelector('.mini-cart--body');
        const updateCheckout = doc.querySelector('[data-html]').content.querySelector('.mini-cart--footer');
        const responseOptions = JSON.parse(doc.querySelector('[data-options]').innerHTML);
        
        // replace mini cart content
        if (cartOption.item_count === 0) {
          document.querySelector('.mini-cart__header').classList.add('mini-cart__no-items')
        } else {
          document.querySelector('.mini-cart__header').classList.remove('mini-cart__no-items')
        }
        document.querySelector('.mini-cart--body').innerHTML = updatedContent.innerHTML;
        document.querySelector('.mini-cart--footer').innerHTML = updateCheckout.innerHTML;
  
        // re bind line item events
        this.bindEvents();
        this.closeButtonEvent();
  
        // update header count
        this.updateHeaderCart(responseOptions.item_count);
  
        // update shipping
        if (  document.querySelector('.mini-cart--shipping') ) {
          this.updateShippingMessage();
        }
  
        // open mini cart
        openMiniCart && this.open();
        this.loading(false);
      }).catch(err => console.log(err)); 
    }
  
    updateCart(lineID, quantity, errorContainer, quantityInput) {
      this.hideErrors();
      this.loading();
  
      fetch(`/cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      body: `quantity=${quantity}&line=${lineID}`
      }).then(res => {
        return res.json();
      }).then(data => {
        if ( data.status === 422 ) {
          const { message } = data;
          quantityInput.value = quantity - 1;
          this.showLineError(errorContainer, message,);
          this.loading(false);
        } else {
          this.updateView();
        }
      }).catch(err => console.log(err))
    }
  
    deleteCart(lineID) {
      this.loading();
      fetch(`/cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      body: `quantity=0&line=${lineID}`
      }).then(res => {
        this.updateView();
      }).catch(err => console.log(err))
    }
  
    addToCart(form) {
      const data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: data
      }).then(response => {
        this.updateView(true);
      }).catch(err => console.log(err))
    }
  
    loading(show = true) {
      if ( show ) {
        this.miniCartLoading.classList.add('is-loading');
      } else {
        this.miniCartLoading.classList.remove('is-loading');
      }
    }
  
    showLineError(errorEl, message) {
      const productInfo = errorEl.dataset.itemTitle;
      if ( productInfo ) {
        errorEl.innerHTML = message.replace(productInfo, `<span>${productInfo}</span>`);
      } else {
        errorEl.textContent = message;
      }
  
      if ( window.innerWidth < 990 ) {
        const productInfoWidth = errorEl.closest('.mini-cart--item').querySelector('.mini-cart--item-content').clientWidth;
        errorEl.style.width = productInfoWidth + 'px';
      }
      errorEl.style.display = 'block';
    }
  
  
    hideErrors() {
      document.querySelectorAll('.mini-cart .quantity__error').forEach(errorEl => {
        errorEl.textContent = '';
        errorEl.style.removeProperty('width');
        errorEl.style.display = 'none';
      });
    }
  }
  
  customElements.define('mini-cart', MiniCart);